import Loader from "../genericComponents/Loader";

const MobileGrid = ({ onClick, handleSetSelectedItems,columns,multiSelectedItemOptions,getSelectedItemOptions,
        getItemOptions, data, MobileComponent, selectedItems }) => {
        if (!data) return (<Loader text={"Loading data..."} />);                
        return data.items.map((item, i) =>{  return(                
                        <MobileComponent
                                item={item}
                                key={item.id}
                                columns={columns}
                                getSelectedItemOptions={getSelectedItemOptions}
                                multiSelectedItemOptions={multiSelectedItemOptions}
                                onSelectedChanged={(multiSelectedItemOptions||getSelectedItemOptions&&getSelectedItemOptions(selectedItems[0]))?handleSetSelectedItems:null}
                                isSelected={selectedItems.find((x) => x.id === item.uuid)}
                                onClick={onClick}
                                getItemOptions={getItemOptions} />
        )})
}

export default MobileGrid;